module.exports = __webpack_public_path__ + "static/media/edge-logo.828ed918.svg";